import React, { useContext, useState } from "react";
import { auth, provider, db, storage } from "../components/firebase";

const Appcontext = React.createContext();

const useProvider = () => {
  return useContext(Appcontext);
};

const StateProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  auth.onAuthStateChanged((user) => {
    setUser(user);
  });
  const value = { user, auth, provider, db, storage };
  return <Appcontext.Provider value={value}>{children}</Appcontext.Provider>;
};

export default StateProvider;
export { useProvider };
